import { TextValue } from '../_general';

export enum BillingTypeEnum {
    NONE = 0,
    ACADEMIC,
    INSTITUTIONAL,
    TRANSNETYX_COMMERCIAL,
    TACONIC_AND_AFFILIATES,
}

export const billingTypeText: { [key in BillingTypeEnum]: string } = {
    [BillingTypeEnum.NONE]: '',
    [BillingTypeEnum.ACADEMIC]: 'Academic',
    [BillingTypeEnum.INSTITUTIONAL]: 'Institutional',
    [BillingTypeEnum.TRANSNETYX_COMMERCIAL]: 'Transnetyx Commercial',
    [BillingTypeEnum.TACONIC_AND_AFFILIATES]: 'Taconic and Affiliates',
};

export const billingTypes: TextValue[] = [
    { text: billingTypeText[BillingTypeEnum.NONE], value: BillingTypeEnum.NONE },
    { text: billingTypeText[BillingTypeEnum.ACADEMIC], value: BillingTypeEnum.ACADEMIC },
    { text: billingTypeText[BillingTypeEnum.INSTITUTIONAL], value: BillingTypeEnum.INSTITUTIONAL },
    { text: billingTypeText[BillingTypeEnum.TRANSNETYX_COMMERCIAL], value: BillingTypeEnum.TRANSNETYX_COMMERCIAL },
    { text: billingTypeText[BillingTypeEnum.TACONIC_AND_AFFILIATES], value: BillingTypeEnum.TACONIC_AND_AFFILIATES },
];
